import axios, { AxiosRequestHeaders, AxiosResponse } from 'axios';
import { makeAutoObservable } from 'mobx';
import { IRequestOptions } from '../models/requests/http.models';
import { IRequestStore } from '../models/stores/requests.models';
import { IRootStore } from '../models/stores/root.models';

export class RequestsStore implements IRequestStore {

  public readonly rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });

    this.rootStore = rootStore;
  }

  public async request(options: IRequestOptions): Promise<AxiosResponse> {
    const { route, token, ...axiosOptions } = options;

    const headers: AxiosRequestHeaders = {
      ...options.headers,
    };
    if (typeof options.token === 'string') {
      headers.authorization = options.token;
    }

    const response = await axios({
      ...axiosOptions,
      url: options.route,
      headers,
      responseType: 'text',
      transformResponse: (res) => res,
    });

    if (typeof response.data !== 'string') {
      throw new Error('Invalid response data');
    }

    return response;
  }

  public async text(options: IRequestOptions): Promise<string> {
    const response = await this.request(options);

    return response.data;
  }

  public async json<TResponse>(options: IRequestOptions): Promise<TResponse> {
    const response = await this.text(options);
    const data: TResponse = JSON.parse(response);
    return data;
  }

}
